import req from '@sportninja/common/api/request'
import { useState } from 'react'
import { Flex } from '../../Layout'

import LoadingSpinner from '../../LoadingSpinner'
import OptionButtonIcon from './Icon'

const OptionButtonFavourite = ({ entityType, item, isFavourite }) => {
  const [loading, setLoading] = useState(false)
  const [isFav, setIsFav] = useState(isFavourite)

  const onClick = async () => {
    setLoading(true)
    try {
      await req(`/favorites/${entityType}/${item.id}`, {
        method: isFav ? 'DELETE' : 'POST',
      })
      setIsFav(!isFav)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Flex noFlex alignItems='center' justifyContent='center'>
      {loading ? (
        <div style={{ width: 18 }}>
          <LoadingSpinner size={1.3} borderSize={1.8} />
        </div>
      ) : (
        <OptionButtonIcon
          faType={isFav ? 'fas' : 'far'}
          name='star'
          onClick={onClick}
        />
      )}
    </Flex>
  )
}

export default OptionButtonFavourite
